import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";

export const MT12 = styled.div`
  margin-top: 12px;
`